import { render, staticRenderFns } from "./VStatusMilestone.vue?vue&type=template&id=53de1260&"
import script from "./VStatusMilestone.vue?vue&type=script&lang=js&"
export * from "./VStatusMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports